import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractStandardClause from "../StandardClause";

class StandardClause extends AbstractStandardClause {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-standard-clauses-ipr';
  }
}

export default StandardClause;
